import Axios from "axios";
import { useEffect, useState } from "react";
import { ConfigService } from "../config/ConfigService";

/**
 *
 * @param app Roxen module name
 * @param variable Config variable name without the app prefix (optional)
 * @returns
 */
export function useConfig(app: string, variable: string = "") {
  const [config, setConfig] = useState<{ [key: string]: any }>();

  useEffect(() => {
    const controller = new AbortController();

    async function getConfig() {
      try {
        const config = await ConfigService.query(app, variable, {
          signal: controller.signal,
        });
        setConfig(config);
      } catch (e: any) {
        if (Axios.isCancel(e) || e?.name === "AbortError") {
          return;
        }
        // No user-facing toast (optional configs legitimately 404 on some
        // tenants) but real failures must stay visible in the console.
        console.error(`Config query for ${app} failed`, e);
      }
    }

    getConfig();

    return () => {
      controller.abort();
    };
  }, [app, variable]);

  return config;
}
